export enum RecentActivityCategory {
  DEPOSITS = 'deposits',
  REDEMPTIONS = 'redemptions',
  REFERRALS = 'referrals',
  SPROUTS = 'sprouts',
  PROMOTIONS = 'promotions',
  MISSIONS = 'missions'
}

export enum RecentActivityType {
  GANAS_DEPOSITED = 'ganas_deposited',
  GANAS_RECEIVED = 'ganas_received',
  GANAS_SHARED = 'ganas_shared',
  REWARD_REDEEMED = 'reward_redeemed',
  REFERRAL_SENT = 'referral_sent',
  REMINDER_SENT = 'reminder_sent',
  SPROUT_REGISTERED = 'sprout_registered',
  GANARBOL_REACHED = 'ganarbol_reached',
  PROMOTION_ENTERED = 'promotion_entered',
  PROMOTION_WON = 'promotion_won',
  PROMOTION_CLAIMED = 'promotion_claimed',
  MISSION_COMPLETED = 'mission_completed',
  CARD_ADDED = 'card_added',
  TAX_DOC_ADDED = 'tax_doc_added'
}

export type RecentActivityScope = 'own' | 'network';

export interface IRecentActivityItem {
  activity_type: RecentActivityType;
  category: RecentActivityCategory | 'account';
  scope: RecentActivityScope;
  date: string;
  timestamp: string | null;
  title: string;
  title_en: string;
  title_es: string;
  entity_name: string | null;
  amount: string | null;
  source_id: string;
  actor_id: number | null;
  metadata: Record<string, unknown>;
}
